import { Toast } from "bootstrap";

export interface modulePage {
    readonly name: string,
    init(): void
}

export class Application {
    private appLoaded = false;
    private modulesLoaded: string[] = [];

    private modules: Array<modulePage> = [];

    public addModule = (module: modulePage) => {
        this.modules.push(module);
    }

    public addModules = (modules: Array<modulePage>) => {
        this.modules = this.modules.concat(modules);
    }

    private documentEvents = () => {
        const toastElList = [].slice.call(document.querySelectorAll(".toast-session"))
        toastElList.map(function (toastEl) {
            const toast = new Toast(toastEl);
            toast.show();
        });

        const logoutBtns = document.querySelectorAll(".logout-btn") as NodeListOf<HTMLElement>;
        Array.from(logoutBtns).forEach(logoutBtn => {
            logoutBtn.addEventListener("click", e => {
                e.preventDefault();
                const logoutForm = document.getElementById("logout-form") as HTMLFormElement;
                logoutForm.submit();
            });
        });
    }

    private init = () => {
        this.documentEvents();
    }

    start = () => {
        if (!this.appLoaded) {
            this.init();
        }

        this.modules.forEach(module => {
            if (this.modulesLoaded.find(loaded => loaded === module.name) === undefined) {
                module.init();
                this.modulesLoaded.push(module.constructor.name);
            }
        });
    };
}